import React from "react";
import AttendanceDailySection from "./AttendanceDailySection";
import AttendanceDesktopHeader from "./AttendanceDesktopHeader";
import AttendancePeriodSection from "./AttendancePeriodSection";
import AttendanceStatsSection from "./AttendanceStatsSection";

export default function AttendanceDesktopContent({
  GlassCard,
  ListWrapper,
  activeTab,
  animateChart,
  brand,
  bulkHoverState,
  changeDate,
  changeMonth,
  changeYear,
  currentDate,
  currentMonth,
  currentYear,
  dailyAttendance,
  dailyStats,
  filteredStudents,
  handleBulkStatusChange,
  handleDownloadExcel,
  handleClearSelection,
  handleJumpToDaily,
  handleSaveDaily,
  handleSelectAll,
  handleSelectRow,
  handleShareStats,
  handleStatusChange,
  handleSyncSoteria,
  handleYearMonthClick,
  isDownloadMenuOpen,
  isMobile,
  isSoteriaLoading,
  monthlyData,
  searchQuery,
  selectedDepartment,
  selectedIds,
  setActiveTab,
  setBulkHoverState,
  setCurrentDate,
  setCurrentMonth,
  setCurrentYear,
  setIsDownloadMenuOpen,
  setSearchQuery,
  setSortKey,
  setSortOrder,
  setTargetGroup,
  setViewMode,
  sortKey,
  sortOrder,
  sundaysInMonth,
  targetGroup,
  theme,
  viewMode,
  yearlyData,
  handleMarkDragStart,
  handleSelectDragStart,
  handleDragOver,
  isDragging,
  dragStatus,
  setSelectedIds,
}) {
  return (
    <div className="max-w-7xl mx-auto w-full space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-end gap-6">
        <div>
          <h2 className="text-3xl font-black text-gray-800 flex items-center gap-3 font-do-hyeon">
            <img src="/images/spiral_calendar_animated.png" width={48} alt="icon" className="drop-shadow-md" /> 출석부
          </h2>
          <p className="text-gray-500 text-sm font-medium mt-1 ml-1">오늘의 출석 현황을 한눈에 확인하고 관리하세요.</p>
        </div>
      </div>

      <AttendanceStatsSection
        GlassCard={GlassCard}
        dailyStats={dailyStats}
        filteredCount={filteredStudents.length}
        isMobile={isMobile}
        targetGroup={targetGroup}
      />

      <AttendanceDesktopHeader
        activeTab={activeTab}
        brand={brand}
        changeDate={changeDate}
        changeMonth={changeMonth}
        changeYear={changeYear}
        currentDate={currentDate}
        currentMonth={currentMonth}
        currentYear={currentYear}
        handleDownloadExcel={handleDownloadExcel}
        handleShareStats={handleShareStats}
        isDownloadMenuOpen={isDownloadMenuOpen}
        searchQuery={searchQuery}
        setActiveTab={setActiveTab}
        setCurrentDate={setCurrentDate}
        setCurrentMonth={setCurrentMonth}
        setCurrentYear={setCurrentYear}
        setIsDownloadMenuOpen={setIsDownloadMenuOpen}
        setSearchQuery={setSearchQuery}
        setSortKey={setSortKey}
        setSortOrder={setSortOrder}
        setTargetGroup={setTargetGroup}
        setViewMode={setViewMode}
        sortKey={sortKey}
        sortOrder={sortOrder}
        targetGroup={targetGroup}
        theme={theme}
        viewMode={viewMode}
      />

      {activeTab === "daily" && (
        <ListWrapper
          className={`flex-1 flex flex-col ${isMobile ? "min-h-0 overflow-hidden !bg-transparent !border-none !shadow-none !mt-0" : "min-h-[600px] mt-4"}`}
          {...(!isMobile ? { noHover: true, allowOverflow: true } : {})}
        >
          <AttendanceDailySection
            GlassCard={GlassCard}
            brand={brand}
            bulkHoverState={bulkHoverState}
            dailyAttendance={dailyAttendance}
            dailyStats={dailyStats}
            filteredStudents={filteredStudents}
            handleBulkStatusChange={handleBulkStatusChange}
            handleSaveDaily={handleSaveDaily}
            handleSelectAll={handleSelectAll}
            handleSelectRow={handleSelectRow}
            handleStatusChange={handleStatusChange}
            handleSyncSoteria={handleSyncSoteria}
            handleClearSelection={handleClearSelection}
            isMobile={isMobile}
            isSoteriaLoading={isSoteriaLoading}
            selectedDepartment={selectedDepartment}
            selectedIds={selectedIds}
            setBulkHoverState={setBulkHoverState}
            targetGroup={targetGroup}
            theme={theme}
            viewMode={viewMode}
            handleMarkDragStart={handleMarkDragStart}
            handleSelectDragStart={handleSelectDragStart}
            handleDragOver={handleDragOver}
            isDragging={isDragging}
            dragStatus={dragStatus}
            setSelectedIds={setSelectedIds}
          />
        </ListWrapper>
      )}

      {(activeTab === "monthly" || activeTab === "yearly") && (
        <AttendancePeriodSection
          activeTab={activeTab}
          animateChart={animateChart}
          brand={brand}
          filteredStudents={filteredStudents}
          handleJumpToDaily={handleJumpToDaily}
          handleYearMonthClick={handleYearMonthClick}
          isMobile={isMobile}
          ListWrapper={ListWrapper}
          monthlyData={monthlyData}
          sundaysInMonth={sundaysInMonth}
          yearlyData={yearlyData}
        />
      )}
    </div>
  );
}
